import Close from '@mui/icons-material/Close';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CloseIcon(props: FixMe) {
  return <Close {...props} />;
}

export default CloseIcon;
